import { AnyAction } from 'redux';
import { Screen } from '@stashinvest/product-events-typescript';
import {
	RESET_MANAGED_TRANSITION_EXIT_STATE,
	SET_DEEPEST_CONVERSION_SCREEN,
	SET_DID_SUBMIT_CONVERSION,
	SET_PORTFOLIO_CONVERSION_ACCOUNT_ID,
	type ManagedTransitionExitScreen,
	type ResetManagedTransitionExitStateAction,
	type SetDeepestConversionScreenAction,
	type SetDidSubmitConversionAction,
	type SetPortfolioConversionAccountIdAction,
} from 'stash/actions/portfolioConversion';

export type PortfolioConversionState = {
	accountId: string | null;
	deepestScreen: ManagedTransitionExitScreen | null;
	didSubmitConversion: boolean;
};

const initialState: PortfolioConversionState = {
	accountId: null,
	deepestScreen: null,
	didSubmitConversion: false,
};

const SCREEN_ORDER: ManagedTransitionExitScreen[] = [
	Screen.managedTransitionPrimer,
	Screen.managedTransitionHowItWorks,
	Screen.managedTransitionAccountOverview,
	Screen.managedTransitionAutoStash,
	Screen.managedTransitionSummary,
];

const depthOf = (screen: ManagedTransitionExitScreen | null): number =>
	screen == null ? -1 : SCREEN_ORDER.indexOf(screen);

const portfolioConversionReducer = (
	state: PortfolioConversionState = initialState,
	action: AnyAction
): PortfolioConversionState => {
	switch (action.type) {
		case SET_PORTFOLIO_CONVERSION_ACCOUNT_ID: {
			const { payload } = action as SetPortfolioConversionAccountIdAction;
			return { ...state, accountId: payload.accountId };
		}
		case SET_DEEPEST_CONVERSION_SCREEN: {
			const { payload } = action as SetDeepestConversionScreenAction;
			if (depthOf(payload.screen) <= depthOf(state.deepestScreen)) {
				return state;
			}
			return { ...state, deepestScreen: payload.screen };
		}
		case SET_DID_SUBMIT_CONVERSION: {
			const { payload } = action as SetDidSubmitConversionAction;
			return { ...state, didSubmitConversion: payload.didSubmitConversion };
		}
		case RESET_MANAGED_TRANSITION_EXIT_STATE: {
			void (action as ResetManagedTransitionExitStateAction);
			return {
				...state,
				deepestScreen: null,
				didSubmitConversion: false,
			};
		}
		default:
			return state;
	}
};

export default portfolioConversionReducer;
